import DiscountTable from "./discount-table";

const Discount = ({data}: any) => {
    return (
        <div>
            <DiscountTable data={data}/>
        </div>
    )
}

export default Discount